module.exports = __webpack_public_path__ + "img/tile2.d8e3beec.svg";